module.exports = __webpack_public_path__ + "img/shuiweio.5d22e280.png";